import { isEqual } from 'lodash';

import { CustomerMyBasePayTeamModel } from 'api/backofficeApiClient';

type WithMyBasePayTeam = {
  myBasePayTeam?: CustomerMyBasePayTeamModel;
  MyBasePayTeam?: CustomerMyBasePayTeamModel;
};

export const resolveMyBasePayTeam = (
  data?: WithMyBasePayTeam | null,
): CustomerMyBasePayTeamModel | undefined =>
  data?.myBasePayTeam ?? data?.MyBasePayTeam;

type MyBasePayTeamUserIdKey =
  | 'mbpClientSuccessPartnerUserId'
  | 'mbpBillingRepresentativeUserId'
  | 'mbpCollectionsRepresentativeUserId'
  | 'mspSalesRepresentativeUserId'
  | 'mspWorkforceSpecialistUserId';

type MyBasePayTeamNameKey =
  | 'mbpClientSuccessPartner'
  | 'mbpBillingRepresentative'
  | 'mbpCollectionsRepresentative'
  | 'mspSalesRepresentative'
  | 'mspWorkforceSpecialist';

// Compare userId only — display names are derived (admin map / BE snapshot) and may
// differ between old/new history payloads without an actual assignment change.
export const hasMyBasePayTeamFieldChanged = (
  oldTeam: CustomerMyBasePayTeamModel | undefined,
  newTeam: CustomerMyBasePayTeamModel | undefined,
  userIdKey: MyBasePayTeamUserIdKey,
  _nameKey: MyBasePayTeamNameKey,
): boolean => !isEqual(oldTeam?.[userIdKey], newTeam?.[userIdKey]);

export const getMyBasePayTeamDisplayName = (
  myBasePayTeam: CustomerMyBasePayTeamModel | undefined,
  userIdKey: MyBasePayTeamUserIdKey,
  nameKey: MyBasePayTeamNameKey,
  adminNamesMap: Map<string, string>,
): string | undefined => {
  const nameValue = myBasePayTeam?.[nameKey];
  const resolvedName = typeof nameValue === 'string' ? nameValue : undefined;

  return (
    adminNamesMap.get(myBasePayTeam?.[userIdKey] ?? '') ??
    resolvedName ??
    undefined
  );
};
